import { render, staticRenderFns } from "./TipoMiembroPage.vue?vue&type=template&id=393b1cf1"
import script from "./TipoMiembroPage.js?vue&type=script&lang=js&external"
export * from "./TipoMiembroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports